//@ts-ignore
const apiUrl = (process.env.REACT_APP_BASE_AUTH_API_URL ?? '') + '/generate-token';

// Call the generate-token API to get the JWT token
export async function getToken() {
  try {

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return data
  } catch (error) {
    console.error('Error fetching token:', error);
  }
}

